var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontpageStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 143.658,
    height: 118,
    viewBox: "0 0 143.658 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(-409 -1022.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-66 462.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(475 560.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M48.2,179.106,0,183.634V70.162l48.2-4.528Z",
    transform: "translate(0 -65.634)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M297.81,179.106l48.2,4.528V70.162l-48.2-4.528Z",
    transform: "translate(-249.609 -65.634)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M642.877,179.106l-47.256,4.528V70.162l47.256-4.528Z",
    transform: "translate(-499.219 -65.634)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M56.324,182.657,9.488,187.008V77.98l46.836-4.351Z",
    transform: "translate(-7.952 -72.335)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M298.865,182.657l46.836,4.351V77.98l-46.836-4.351Z",
    transform: "translate(-250.493 -72.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M635.078,182.657l-46.836,4.351V77.98l46.836-4.351Z",
    transform: "translate(-493.034 -72.335)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M114.64,135.494l-35.575,1.248v16.38h30.2V147.2l5.375-.189,8.19,2.528V138.022Z",
    transform: "translate(-66.268 -124.187)",
    fill: "#00a050",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M92.109,625.857,52.183,629.7V615.108l39.926-3.839Z",
    transform: "translate(-43.737 -522.957)",
    fill: "#00a050",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M65.109,346.857,25.183,350.7V336.108l39.926-3.839Z",
    transform: "translate(-21.107 -289.114)",
    fill: "#00a050",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 17.404,
    height: 13.309,
    transform: "translate(71.918 91.639)",
    fill: "#00a050",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 17.404,
    height: 13.309,
    transform: "translate(73.374 18.806)",
    fill: "#00a050",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M696.017,584.652l-27.129,2.3V569.3l27.129-2.3Z",
    transform: "translate(-560.628 -485.847)",
    fill: "#00a050",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M676.017,200.652l-27.129,2.3V185.3l27.129-2.3Z",
    transform: "translate(-543.865 -163.998)",
    fill: "#00a050",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M300.352,62.891c0,5.656-10.241,21.674-10.241,21.674s-10.241-16.018-10.241-21.674a10.241,10.241,0,1,1,20.483,0Z",
    transform: "translate(-210.94 -27.508)",
    fill: "#00a050"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 3.096,
    cy: 3.096,
    r: 3.096,
    transform: "translate(76.074 31.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1080.864,716.342l42.79,6.052,14.828-.989v35.87h-14.828l-42.79-5.225Z",
    transform: "translate(-1028.46 -677.384)",
    fill: "none",
    stroke: "#00a050",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    transform: "translate(50.368 36.951)",
    fill: "#fff",
    stroke: "#00a050",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.255,
    cy: 2.255,
    r: 2.255,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.255,
    cy: 2.255,
    r: 1.505,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    transform: "translate(108.088 42.362)",
    fill: "#fff",
    stroke: "#00a050",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.255,
    cy: 1.804,
    rx: 2.255,
    ry: 1.804,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.255,
    cy: 1.804,
    rx: 1.505,
    ry: 1.054,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    transform: "translate(108.088 77.437)",
    fill: "#fff",
    stroke: "#00a050",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.255,
    cy: 2.255,
    rx: 2.255,
    ry: 2.255,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.255,
    cy: 2.255,
    rx: 1.505,
    ry: 1.505,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    transform: "translate(50.368 72.026)",
    fill: "#fff",
    stroke: "#00a050",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.255,
    cy: 2.255,
    rx: 2.255,
    ry: 2.255,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.255,
    cy: 2.255,
    rx: 1.505,
    ry: 1.505,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontpageStep1);
export default __webpack_public_path__ + "static/media/frontpage_step_1.91ee42e5af0aef5cf93e8e4ad8f38f2d.svg";
export { ForwardRef as ReactComponent };